export const LOGIN_URL = "/api/User/authenticate";
export const USER_URL = "/api/User";
export const GET_SELF_DATA_URL = "/api/User/getselfdata";
export const EDIT_USER_URL = "/api/User/editUser";
export const ENABLE_USER_URL = "/api/User/enable";
export const DISABLE_USER_URL = "/api/User/disable";
export const DOWNLOAD_USERS_URL = "/api/User/downloadUsers";
export const RESET_PASSWORD = "/api/User/ResetPassword";
export const RESET_PASSWORD_ANONYMUS = "/api/User/resetPasswordAnonymus";
export const USER_PASSWORD = "/api/User/password";
export const USER_PASSWORD_ANONYMUS = "/api/User/updatePasswordAnonymus";
export const REFRESH_TOKEN = "/api/User/refreshtoken";
export const PASSWORD_DEFINITION = "/api/DefinirSenha";
export const ROLE_URL = "/api/Role";
export const GET_ROLE_BY_ID_URL = "/api/Role/getRoleById";
export const EDIT_ROLE_URL = "/api/Role/editRole";
export const ROLE_TYPES_URL = "/api/Role/getroletypes";
export const ROLE_LEVELS_URL = "/api/Role/getrolelevels";
export const ROLE_FEATURES_URL = "/api/Role/getallfeatures";
export const DOWNLOAD_ROLES_URL = "/api/Role/downloadRoles";
export const PROVINCE_URL = "/api/Lookup/province";
export const COUNTY_URL = "/api/Lookup/county";
export const COMMUNE_URL = "/api/Lookup/commune";
export const NATIONALITY_URL = "/api/Lookup/Nationality";
export const PARTNER_URL = "/api/Lookup/Partner";
export const GENDER_URL = "/api/Lookup/Gender";
export const ADMINISTRATIVE_POSITION_URL = "/api/Lookup/AdministrativePosition";
export const IDENTIFICATION_DOCUMENT_TYPE_URL =
  "/api/Lookup/IdentificationDocumentType";
export const ADD_ITEM_LOOKUP = "/api/Lookup/AddItemToLookup";
export const ENABLE_DISABLE_LOOKUP_ITEM = "/api/Lookup/EnableDisableLookupItem";
export const DELETE_LOOKUP_ITEM = "/api/Lookup/DeleteLookupItem";
export const UPDATE_ITEM_LOOKUP = "/api/Lookup/UpdateLookupItem";
export const GET_AUDIT_TYPOLOGIES = "/api/Audit/getAuditTypologies";
export const GET_AUDIT_LIST_DEFAULT = "/api/Audit/getAuditListDefault";
export const GET_AUDIT_LIST_ADMIN = "/api/Audit/getAuditListAdmin";
export const DOWNLOAD_AUDIT_DEFAULT = "/api/Audit/downloadAuditDefault";
export const DOWNLOAD_AUDIT_ADMIN = "/api/Audit/downloadAuditAdmin";
export const ADD_ITEM_LOOKUP_BULK = "/api/Lookup/AddItemToLookupBulk";

export const ORGANIZATION_URL = "/api/Organization";
export const EDIT_ORGANIZATION_URL = "/api/Organization/updateOrganization";

export const INDICATOR_URL = "/api/Indicator";
export const INDICATOR_TYPE_URL = "/api/Lookup/Indicatortypes";
export const INDICATOR_STATE_URL = "/api/Lookup/IndicatorStates";
export const INDICATOR_SUB_SYSTEM_URL = "/api/Lookup/SubSystem";
export const INDICATOR_COLLECTION_FREQUENCY_URL =
  "/api/Lookup/CollectionFrequency";
export const INDICATOR_DATA_PERIOD_URL = "/api/Lookup/DataPeriod";
export const INDICATOR_METRIC_URL = "/api/Lookup/Metrics";
export const INDICATOR_LEVEL_URL = "/api/Lookup/IndicatorClassificationLevels";
export const INDICATOR_VARIATION_URL = "/api/Lookup/IndicatorReadingVariations";
export const INDICATOR_SYMBOL_URL = "/api/Lookup/Symbol";
export const INDICATOR_COLLECTION_TYPE_URL =
  "/api/Lookup/IndicatorCollectionType";

export const INDICATOR_ANALYTICS_URL =
  "/api/IndicatorDataReport/indicator-analytics";
export const INDICATOR_REGION_URL = "/api/IndicatorDataReport/region-analytics";
export const INDICATOR_REGION_HISTORY_URL =
  "/api/IndicatorDataReport/region-history";

export const INDICATOR_DATA_URL = "/api/IndicatorData";
export const INDICATOR_DATA_SEED_MODEL = "/api/IndicatorData/seed-model";
export const INDICATOR_DATA_SEED = "/api/IndicatorData/seed";
export const INDICATOR_DATA_STATES_URL = "/api/Lookup/IndicatorDataStates";

export const OCCURENCE_URL = "/api/Occurrence";
export const OCCURENCE_TYPE_URL = "/api/Lookup/OccurrenceTypes";
export const OCCURENCE_LEVEL_URL = "/api/Lookup/OccurrenceLevels";
export const OCCURENCE_FINISH = "/api/Occurrence/finish";

export const OCCURENCE_ALERT_SAN_URL = "/api/OccurrenceAlertSan";
export const OCCURENCE_ALERT_SEVERITY_URL = "/api/Lookup/AlertSanSeverities";

export const DOCUMENTS_URL = "/api/Documents";
export const DOCUMENTS_PRIVATE_URL = "/api/Documents/private";

export const FORBIDDEN_ROUTE = "/forbidden";
export const INTERNAL_ERROR_ROUTE = "/internalerror";
export const NOT_FOUND_ROUTE = "/notfound";

export const BULLETIN_URL = "/api/Bulletins";
export const BULLETIN_INDICATOR_URL = "/api/BulletinIndicator";
export const BULLETIN_TYPE_URL = "/api/Lookup/Bulletintypes";

export const GRAPH_TYPE_URL = "/api/Lookup/GraphicTypes";

export const DASHBOARD_URL = "/api/Dashboard";

export const AUDIT_TYPOLOGIES_URL = "/api/Audit/getAuditTypologies";
export const AUDIT_DOWNLOAD_DEFAULT_URL = "/api/Audit/downloadAuditDefault";

export const ALERT_SAN_URL = "/api/AlertSan";
